import {handleError} from '../../common/utils/errorHandling';
import httpClient from '../../common/services/httpClient';

interface PlaceListingDto {
  readonly id: string;
  readonly name: string;
  readonly type: string;
}

class PlacesService {
  public async getAllPlaces(): Promise<PlaceListingDto[]> {
    return handleError(
      () => httpClient.get<PlaceListingDto[]>('/places'),
      'Error fetching places:',
      () => []
    );
  }
}

const placesService = new PlacesService();
export default placesService;
